/** Standard golf scorecard cell notation (circles / squares vs par). */

interface Props {
  score: number | null;
  par: number;
  size?: number;
  className?: string;
}

export function ScoreNotation({ score, par, size = 30, className = '' }: Props) {
  if (score == null || !Number.isFinite(score)) {
    return (
      <div
        className={`flex items-center justify-center font-serif text-[13px] font-bold text-mute ${className}`}
        style={{ width: size, height: size }}
      >
        —
      </div>
    );
  }

  const d = score - par;
  const underPar = d < 0;
  const num = (
    <span className={`relative z-[1] font-serif text-[13px] font-bold leading-none ${underPar ? 'text-bad' : 'text-ink'}`}>
      {score}
    </span>
  );

  if (d <= -2) {
    return (
      <div
        className={`relative flex items-center justify-center ${className}`}
        style={{ width: size, height: size }}
      >
        <div className="absolute inset-0 rounded-full border-2 border-navy" />
        <div className="absolute inset-[4px] rounded-full border border-navy" />
        {num}
      </div>
    );
  }

  if (d === -1) {
    return (
      <div
        className={`flex items-center justify-center rounded-full border-2 border-navy ${className}`}
        style={{ width: size, height: size }}
      >
        {num}
      </div>
    );
  }

  if (d === 0) {
    return (
      <div
        className={`flex items-center justify-center ${className}`}
        style={{ width: size, height: size }}
      >
        {num}
      </div>
    );
  }

  if (d === 1) {
    return (
      <div
        className={`flex items-center justify-center border-2 border-navy ${className}`}
        style={{ width: size, height: size }}
      >
        {num}
      </div>
    );
  }

  if (d === 2) {
    return (
      <div
        className={`relative flex items-center justify-center ${className}`}
        style={{ width: size, height: size }}
      >
        <div className="absolute inset-0 border-2 border-navy" />
        <div className="absolute inset-[4px] border border-navy" />
        {num}
      </div>
    );
  }

  return (
    <div
      className={`flex items-center justify-center border-2 border-navy bg-navy ${className}`}
      style={{ width: size, height: size }}
    >
      <span className="font-serif text-[13px] font-bold leading-none text-cream">{score}</span>
    </div>
  );
}
